/**
 * Utility functions for handling boolean-type styles consistently.
 */
export class BooleanStyleUtils {
  /**
   * Parses a boolean-type style value consistently.
   *
   * @param value - The style value to parse (can be boolean, string, or undefined)
   * @returns true if the value represents a truthy boolean, false otherwise
   *
   * Behavior:
   * - true -> true
   * - false -> false
   * - "true" -> true
   * - "false" -> false
   * - "TRUE" -> false (only lowercase supported)
   * - "FALSE" -> false (only lowercase supported)
   * - "blah" -> false
   * - undefined -> false
   * - null -> false
   */
  static isBooleanStyleEnabled(
    value: string | boolean | undefined | null,
  ): boolean {
    if (value === undefined || value === null) {
      return false;
    }

    if (typeof value === "boolean") {
      return value;
    }

    if (typeof value === "string") {
      return value === "true";
    }

    return false;
  }
}
